import React, { useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';
import _ from 'lodash';
import PropTypes from 'prop-types';
import cardStyles from '../Card.module.css';
import userCardStyles from './UserCard.module.css';
// import { CONTAINERS } from '../cardNavigationComponent/cardNavigationRedux';
import { userToUserManagementObj } from '../../userManagement/lib/Mapper';
import {
  DD_MM_YYYY_FORMAT,
  CERTIFICATES_VARIABLE_NAME,
  SKILLLEVEL_VARIABLE_NAME,
} from '../../../HelperMethods/constants';
import * as stopsActions from '../../../actions/stopsActions';
import { ATTRIBUTE_TYPE } from '../../../HelperMethods/FormUtils';
import { determineIfUserHasAccessToResource } from '../../../HelperMethods/UserUtilities';
import { ENTITY_ACCESS_TYPE, RESOURCES, RESOURCE_TYPE } from '../../../HelperMethods/role-resource-constants';

import * as userManagementActions from '../../userManagement/redux/actions';
import { loadContacts } from '../../contactManagement/redux/actions';
import { loadVendors } from '../../vendorManagement/redux/actions';
import VENDOR_SCHEMA_CONSTANTS from '../../vendorManagement/vendorManagementForm/schemaConstants';
import { ReactComponent as DownArrow } from '../../../icons/arrow-down.svg';
import { ReactComponent as UpArrow } from '../../../icons/arrow-copy.svg';
import ContactCard from '../contactCard/ContactCard';
import { getAllGlobalTaskAttributesSelector } from '../../generalConfig/attributeManagement/redux/reducer';

const UserCard = React.memo(function AssigneeCard({ assigneeId }) {
  const dispatch = useDispatch();
  const [isLoading, handleLoading] = useState(true);
  const field = useSelector((state) => state.appReducer.selectedField);
  const vendorOptionLoading = useSelector((state) => state.vendorReducer.isVendorPageLoading);
  useEffect(() => {
    dispatch(stopsActions.getStopsByField(field));
    dispatch(userManagementActions.loadPickLists(CERTIFICATES_VARIABLE_NAME));
    dispatch(userManagementActions.loadPickLists(SKILLLEVEL_VARIABLE_NAME));
    dispatch(loadContacts());
    dispatch(loadVendors());
    handleLoading(false);
  }, []);
  const history = useHistory();

  const allAssignees = useSelector((state) => state.taskViewPageReducer.usersAtFieldLevel);
  const assignee = useMemo(() => allAssignees.find((u) => u.id === assigneeId), [allAssignees, assigneeId]);
  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);

  const teams = useSelector((state) => state.teamReducer.teams);
  const vendors = useSelector((state) => state.vendorReducer.vendors);
  const areas = useSelector((state) => state.appReducer.areasForDropdown);
  const fields = useSelector((state) => state.stopsReducer.fieldsForDropdown);
  const settings = useSelector((state) => state.appReducer.settings);
  const packagesInfo = useSelector((state) => state.appReducer.packagesInfo);
  const editAssignee = (id) => {
    const url = window.location.pathname;
    dispatch({ type: 'USER_MANAGEMENT_PAGE_RETURN_TASK_EDIT_PAGE_STATE', url });

    history.push({ pathname: `/usermanagement/singleedit/${id}`, selectedUser: assignee });
  };
  const editPermission = determineIfUserHasAccessToResource({
    resourceType: RESOURCE_TYPE.ENTITY,
    resource: RESOURCES.ENTITY.USER,
    entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
    user: loggedInUser,
    packageName: settings?.package,
    packagesInfo,
  });

  if (!assignee) return <div className={cardStyles.card}>Assignee Not Available</div>;
  const userObj = userToUserManagementObj({
    user: assignee,
    teams,
    rawAreas: areas,
    fieldsDict: _.keyBy(fields, 'id'),
    vendorsDict: _.keyBy(vendors, 'id'),
  });
  return (
    <div className={userCardStyles.userCard}>
      <div className={cardStyles.cardHeader}>
        <div className={cardStyles.taskHeaderLines} style={{ paddingLeft: '24px' }}>
          <div className={cardStyles.mainHeader}>{`${assignee.firstName} ${assignee.lastName}`}</div>
          <div style={{ display: 'flex' }}>
            <div>{assignee.email}</div>
            {editPermission && (
              <div
                className="p-cursor"
                style={{ marginLeft: '20px' }}
                onClick={() => {
                  editAssignee(assigneeId);
                }}
              >
                <Icon name="edit outline" />
              </div>
            )}
          </div>
          <div>{assignee?.businessTitle}</div>
        </div>
      </div>
      <div className={cardStyles.cardContent}>
        {isLoading || vendorOptionLoading ? (
          <div className="hover-loading">
            <div className="joyn2-loader" />
          </div>
        ) : (
          <AssigneeDetails assignee={userObj} />
        )}
      </div>
    </div>
  );
});

UserCard.propTypes = {
  assigneeId: PropTypes.string.isRequired,
};

function VendorDetails({ assignee }) {
  const [openVendorDetail, handleVendorDetails] = useState(true);
  const handleToggle = () => {
    handleVendorDetails((openState) => !openState);
  };
  const vendorsList = useSelector((state) => state.vendorReducer.vendors);
  const reqVendor = (vendorsList || []).find((vendor) => vendor.id === assignee.vendorId);

  return (
    <>
      <div
        style={{
          background: 'rgba(200, 244, 240, 0.17)',
          padding: '0 16px 0 24px',
          justifyContent: 'space-between',
          minHeight: '41px',
          display: 'flex',
        }}
      >
        <div className={userCardStyles.rowTitle}>Vendor Details</div>
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
            onClick={handleToggle}
          >
            {openVendorDetail ? <UpArrow /> : <DownArrow />}
          </div>
        </div>
      </div>
      {openVendorDetail ? (
        <>
          {Object.values(VENDOR_SCHEMA_CONSTANTS)
            .filter((item) => !item.hide)
            .map((item, index) => {
              return (
                <div className={userCardStyles.row} key={index}>
                  <div className={userCardStyles.subRowLabel}>{item.displayName}</div>
                  {item.type !== ATTRIBUTE_TYPE.CHECKBOX ? (
                    <div className={userCardStyles.rowValue}>{`${reqVendor?.[item.path] || '-'}`}</div>
                  ) : (
                    <div className={userCardStyles.rowValue}>{reqVendor?.[item.path] ? `Yes` : `No`}</div>
                  )}
                </div>
              );
            })}

          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Hourly Rate</div>
            <div className={userCardStyles.rowValue}>${assignee?.contractHourlyRate}</div>
          </div>
        </>
      ) : null}
    </>
  );
}

VendorDetails.propTypes = {
  assignee: PropTypes.object,
};

function SkillCertificationDetails({ assignee }) {
  const [openSkillCertification, handleSkillCertification] = useState(true);
  const handleToggle = () => {
    handleSkillCertification((openState) => !openState);
  };
  return (
    <>
      <div
        style={{
          background: 'rgba(200, 244, 240, 0.17)',
          padding: '0 16px 0 24px',
          justifyContent: 'space-between',
          minHeight: '41px',
          display: 'flex',
        }}
      >
        <div className={userCardStyles.rowTitle}>Skill level & Certifications</div>
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
            onClick={handleToggle}
          >
            {openSkillCertification ? <UpArrow /> : <DownArrow />}
          </div>
        </div>
      </div>
      {openSkillCertification ? (
        <div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Skill Level</div>
            <div className={userCardStyles.rowValue}>{assignee?.skillLevel?.name}</div>
          </div>
          {assignee?.certificates?.map((certificate) => (
            <>
              <div className={userCardStyles.row} key={certificate.id}>
                <div className={userCardStyles.subRowLabel}>{certificate?.name}</div>
                <div className={userCardStyles.rowValue}>
                  {certificate.isExpirable ? moment(certificate?.expiryDate).format(DD_MM_YYYY_FORMAT) : null}
                </div>
              </div>
            </>
          ))}
        </div>
      ) : null}
    </>
  );
}

SkillCertificationDetails.propTypes = {
  assignee: PropTypes.shape({
    certificates: PropTypes.array,
    skillLevel: PropTypes.object,
  }).isRequired,
};

function AttributeDetails({ assignee }) {
  const taskAttributes = useSelector(getAllGlobalTaskAttributesSelector);
  const taskAttributeDict = _.keyBy(taskAttributes, 'id');
  const [openAttributeDetails, handleAttributeDetails] = useState(true);
  const handleToggle = () => {
    handleAttributeDetails((openState) => !openState);
  };
  return (
    <>
      <div
        style={{
          background: 'rgba(200, 244, 240, 0.17)',
          padding: '0 16px 0 24px',
          justifyContent: 'space-between',
          minHeight: '41px',
          display: 'flex',
        }}
      >
        <div className={userCardStyles.rowTitle}>Approval Status</div>
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
            onClick={handleToggle}
          >
            {openAttributeDetails ? <UpArrow /> : <DownArrow />}
          </div>
        </div>
      </div>
      {openAttributeDetails ? (
        <div>
          {assignee?.approver?.rows?.map((approver) => (
            <>
              <div className={userCardStyles.row} key={approver.globalAttribute}>
                <div className={userCardStyles.subRowLabel}>
                  {taskAttributeDict[approver.globalAttribute].attributeDisplayName}
                </div>
                <div className={userCardStyles.rowValue}>{approver.limit}</div>
              </div>
            </>
          ))}
        </div>
      ) : null}
    </>
  );
}

AttributeDetails.propTypes = {
  assignee: PropTypes.shape({
    approver: PropTypes.object,
  }).isRequired,
};

function SchedulingLocationDetails({ assignee }) {
  const [openSchedulingLocation, handleSchedulingLocation] = useState(true);
  const handleToggle = () => {
    handleSchedulingLocation((openState) => !openState);
  };
  const offDays = assignee?.offDays.map((day) => moment(day).format(DD_MM_YYYY_FORMAT)).join(', ');
  const onDays = assignee?.onDays.map((day) => moment(day).format(DD_MM_YYYY_FORMAT)).join(', ');
  return (
    <>
      <div
        style={{
          background: 'rgba(200, 244, 240, 0.17)',
          padding: '0 16px 0 24px',
          justifyContent: 'space-between',
          minHeight: '41px',
          display: 'flex',
        }}
      >
        <div className={userCardStyles.rowTitle}>Scheduling & Location</div>
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
            onClick={handleToggle}
          >
            {openSchedulingLocation ? <UpArrow /> : <DownArrow />}
          </div>
        </div>
      </div>
      {openSchedulingLocation ? (
        <div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Start Time</div>
            <div className={userCardStyles.rowValue}>{moment(assignee?.startTime, 'HH:mm').format('h:mm A')}</div>
          </div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>End Time</div>
            <div className={userCardStyles.rowValue}>{moment(assignee?.endTime, 'HH:mm').format('h:mm A')}</div>
          </div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Time Zone</div>
            <div className={userCardStyles.rowValue}>{assignee?.timeZone}</div>
          </div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Start Stop</div>
            <div className={userCardStyles.rowValue}>{assignee?.startStopName}</div>
          </div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>End Stop</div>
            <div className={userCardStyles.rowValue}>{assignee?.endStopName}</div>
          </div>
          {assignee?.hitchPattern.map((hitch, index) => (
            <div key={index}>
              <div className={userCardStyles.row}>
                <div className={userCardStyles.subRowLabel}>Hitch Work Days</div>
                <div className={userCardStyles.rowValue}>{hitch?.hitchWorkDays}</div>
              </div>
              <div className={userCardStyles.row}>
                <div className={userCardStyles.subRowLabel}>Hitch Off Days</div>
                <div className={userCardStyles.rowValue}>{hitch?.hitchOffDays}</div>
              </div>
            </div>
          ))}
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Off Days</div>
            <div className={userCardStyles.rowValue} title={offDays}>
              {offDays}
            </div>
          </div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>On Days</div>
            <div className={userCardStyles.rowValue} title={onDays}>
              {onDays}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

SchedulingLocationDetails.propTypes = {
  assignee: PropTypes.object,
};

function MiscellaneousInfo({ assignee }) {
  const [openMiscellaneousInfo, handleMiscellaneousInfo] = useState(true);
  const handleToggle = () => {
    handleMiscellaneousInfo((openState) => !openState);
  };
  return (
    <>
      <div
        style={{
          background: 'rgba(200, 244, 240, 0.17)',
          padding: '0 16px 0 24px',
          justifyContent: 'space-between',
          minHeight: '41px',
          display: 'flex',
        }}
      >
        <div className={userCardStyles.rowTitle}>Miscellaneous Info</div>
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
            onClick={handleToggle}
          >
            {openMiscellaneousInfo ? <UpArrow /> : <DownArrow />}
          </div>
        </div>
      </div>
      {openMiscellaneousInfo ? (
        <div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Teams</div>
            <div className={userCardStyles.rowValue} title={assignee?.teamNames}>
              {assignee?.teamNames}
            </div>
          </div>
          <div className={userCardStyles.row}>
            <div className={userCardStyles.subRowLabel}>Areas</div>
            <div className={userCardStyles.rowValue} title={assignee?.areaNames}>
              {assignee?.areaNames}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

MiscellaneousInfo.propTypes = {
  assignee: PropTypes.shape({
    teamNames: PropTypes.string,
    areaNames: PropTypes.string,
  }).isRequired,
};

function ContactDetails({ assignee }) {
  const [openContactDetail, handleContactDetail] = useState(true);
  const handleToggle = () => {
    handleContactDetail((openState) => !openState);
  };
  const contacts = useSelector((state) => state.contactReducer.contacts);
  const contactDict = _.keyBy(contacts, 'id');
  const userContacts = [];
  assignee?.contacts?.forEach((id) => {
    if (contactDict[id]) {
      if (id === assignee.defaultContact) {
        userContacts.unshift({ id, isDefault: true, ...contactDict[id] });
      } else {
        userContacts.push({ id, isDefault: false, ...contactDict[id] });
      }
    }
  });
  return (
    <>
      <div
        style={{
          background: 'rgba(200, 244, 240, 0.17)',
          padding: '0 16px 0 24px',
          justifyContent: 'space-between',
          minHeight: '41px',
          display: 'flex',
        }}
      >
        <div className={userCardStyles.rowTitle}>Contact Details</div>
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
            onClick={handleToggle}
          >
            {openContactDetail ? <UpArrow /> : <DownArrow />}
          </div>
        </div>
      </div>
      {openContactDetail ? (
        <div>
          {userContacts.map((userContact) => (
            <ContactCard {...userContact} key={userContact.id} />
          ))}
        </div>
      ) : null}
    </>
  );
}

ContactDetails.propTypes = {
  assignee: PropTypes.shape({
    contacts: PropTypes.array,
    defaultContact: PropTypes.string,
  }).isRequired,
};

function AssigneeDetails({ assignee }) {
  return (
    <>
      {assignee?.vendorId && <VendorDetails assignee={assignee} />}
      {assignee?.contacts?.length > 0 && <ContactDetails assignee={assignee} />}
      <SkillCertificationDetails assignee={assignee} />
      <SchedulingLocationDetails assignee={assignee} />
      {assignee?.approver?.enabled && <AttributeDetails assignee={assignee} />}
      <MiscellaneousInfo assignee={assignee} />
    </>
  );
}

AssigneeDetails.propTypes = {
  assignee: PropTypes.object,
};

export default UserCard;
